import BaseAPI from "../base";

class WechatService extends BaseAPI {
  // 获取验证码
  initJsJdk(params) {
    return this.post({
      url: "/WeChat/InitJsJdk",
      data: params,
    });
  }
}

export default new WechatService();
